import appConfig from "AppConfig";
import navigationService from "NavigationService";

class InitialPage {
  private privates: { overriddenPath: string | null };
  defaultPath: string;

  constructor() {
    this.privates = { overriddenPath: null };
    this.defaultPath = "#/" + appConfig.initialPage;
  }

  logonRedirectPath(): string;
  logonRedirectPath(value: string | null): void;
  logonRedirectPath(value?: string | null): string | void {
    if (value === undefined) {
      return this.privates.overriddenPath ?? this.defaultPath;
    } else {
      this.privates.overriddenPath = value;
    }
  }

  navigateToSelf(): void {
    navigationService.changePage(this.logonRedirectPath());
  }
}

export default new InitialPage();
